<template>
  <div class="userinfo-wrapper">
    <el-form ref="form" :model="form" :rules="rules" label-width="80px" class="userinfo-box">
      <h3 class="title">我的资料</h3>
      
      <el-form-item label="手机号码" prop="phone"
        :rules="[
          { required: true, message: '请输入手机号码', trigger: 'blur' },
        ]"
      >
        <el-input type="text" placeholder="请输入手机号码" v-model="form.phone" :disabled="true"/>
      </el-form-item>

      <el-form-item label="昵称" prop="name"
        :rules="[
          { required: true, message: '请输入昵称', trigger: 'blur' },
        ]"
      >
        <el-input type="text" placeholder="请输入昵称" v-model="form.name"/>
      </el-form-item>
      
      <el-form-item label="性别" prop="gender"
        :rules="[
          { required: true, message: '请选择性别', trigger: 'blur' },
        ]"
      >
        <el-radio-group v-model="form.gender">
          <el-radio label="0">男</el-radio>
          <el-radio label="1">女</el-radio>
        </el-radio-group>
      </el-form-item>
      
      <el-form-item label="年龄" prop="age"
        :rules="[
          { required: true, message: '请输入年龄', trigger: 'blur' },
          { type: 'number', message: '请输入正确的数字', trigger: ['blur', 'change'] }
        ]"
      >
        <el-input type="age" placeholder="请输入年龄" v-model.number="form.age" autocomplete="false"/>
      </el-form-item>
      
      <el-form-item label="email" prop="email"
        :rules="[
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ]"
      >
        <el-input type="email" placeholder="请输入邮箱地址" v-model="form.email"/>
      </el-form-item>

      <el-form-item label="头像" prop="avatar"
        :rules="[
          { required: true, message: '请选择头像图片', trigger: 'blur' },
        ]"
      >
        <el-upload
          action="#"
          list-type="picture-card"
          accept=".jpg,.jpeg,.png,.bmp"
          :auto-upload="true"
          :http-request="uploadImage"
          :on-preview="handleImagePreview"
          :on-remove="handleImageRemove"
          :limit="1"
          :file-list="images"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" v-on:click="onSubmit">保存</el-button>
      </el-form-item>
    </el-form>

    <!-- 海报图片预览框 -->
    <PreviewImage :visible.sync="isPreviewImageShow" v-if="isPreviewImageShow" :imageUrl="images[0].url" />

  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'
import PreviewImage from '@com/common/preview_image'

export default {
  name: 'Userinfo',
  components: {
    PreviewImage,
  },
  data: function () {
    return {
      form: {
        phone: '',
        name: '',
        avatar: '',
        gender: '0',
        age: 0,
        email: '',
      },
      images: [],
      isPreviewImageShow: false,
    }
  },
  computed: {
    ...mapState({
      userinfo: 'userinfo'
    })
  },
  mounted(){
    this.form.phone = this.userinfo.phone
    this.form.name = this.userinfo.name
    this.form.avatar = this.userinfo.avatar
    this.form.gender = this.userinfo.gender+''
    this.form.age = this.userinfo.age
    this.form.email = this.userinfo.email

    this.images.push({
      name: this.userinfo.avatar,
      url: this.userinfo.avatar
    })
  },
  methods: {
    onSubmit() {
      const that = this
      // 为表单绑定验证功能
      that.$refs['form'].validate((valid) => {
        if (!valid) {
          that.$message('用户信息不正确')
          return
        }
            
        if(that.form.avatar.length===0){
          that.$message('头型不能为空')
          return
        }
          
        that.save()
      })
    },
    save() {
      const that = this
      const params = new FormData()
      params.append('id', that.userinfo.id)
      params.append('name', that.form.name)
      params.append('gender', that.form.gender)
      params.append('age', that.form.age)
      params.append('email', that.form.email)
      params.append('avatar', that.form.avatar)

      that.axios
        .post('/user/save',
          params)
        .then(ret => {
          if (ret.code != 0) {
            that.$message("注册信息不正确!")
            that.$message(ret.message)
            return
          }
          // 将username存入vuex
          that.$store.commit('setUserInfo', ret.data)
          //跳转到登陆页
          that.$router.push({ path: '/login' })
        })
    },
    // 自定义图片文件上传
    uploadImage(param) {
      console.log(param)

      const that = this
      var fileObj = param.file;
      // FormData 对象
      var form = new FormData();
      // 文件对象
      form.append("file", fileObj)
      that.axios
        .post('/file/upload',
          form)
        .then(res => {
          if (res.code != 0) {
            that.$message("上传失败!")
            return
          }

          //清空图片数组
          that.images.splice(0)
          that.images.push({
            name: res.data.fileName,
            url: res.data.url
          })

          that.form.avatar = res.data.url

          that.$message({
            message: '恭喜你，上传成功!',
            type: 'success'
          })
        })
        .catch(()=>{
          this.$message("上传失败!")
          return
        })
        
    },
    handleImageRemove(file) {
      console.log(file);
      this.formData.images.splice(0)
    },
    handleImagePreview(file) {
      console.log(file)
      this.isPreviewImageShow = true
    },
  }
}
</script>

<style lang="stylus" scoped>
.userinfo-wrapper
  .userinfo-box
    border: 1px solid #DCDFE6
    width: 500px
    margin: 180px auto
    padding: 35px 35px 15px 35px
    border-radius: 5px
    -webkit-border-radius: 5px
    -moz-border-radius: 5px
    box-shadow: 0 0 25px #909399
  .title
    text-align: center
    margin: 0 auto 40px auto
    color: #303133
</style>